import React from 'react';
import { Radio } from '@material-ui/core';
import clsx from 'clsx';

import { ICustomRadioProps } from './interfaces';
import { useStyles } from './styles';

const CustomRadio: React.FC<ICustomRadioProps> = ({
  error = false,
  ...props
}: ICustomRadioProps) => {
  const classes = useStyles();

  return (
    <Radio className={clsx({ [classes.erroredRadio]: error })} {...props} />
  );
};

export default CustomRadio;
